module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1470
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16